import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/components.css";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleReset = async () => {
    const email = location.state?.email;
    const otp = location.state?.otp;

    if (password && password === rePassword && email && otp) {
      try {
        const response = await apiService.postData("admin/reset-password", {
          email: email,
          otp: otp,
          new_pass: password,
          confirm_pass: rePassword,
        });

        if (response.code === 200 && !response.error) {
          toast.success(response.message || "Password reset successfully!");
          setTimeout(() => navigate("/"), 2000);
        } else {
          toast.error(response.message || "Reset failed. Please try again.");
        }
      } catch (error) {
      }
    } else {
    }
  };

  return (
    <div id="app">
      <section className="section">
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-4">
              <div className="text-center">
                <img
                  src="../assets/img/logo.png"
                  alt="logo"
                  width="250"
                />
              </div>

              <div className="card card-primary">
                <div className="card-header text-center">
                  <h4>Reset Password</h4>
                </div>
                <div className="card-body">
                  <p className="text-muted text-center">
                    We will send a link to reset your password
                  </p>
                  <div className="form-group">
                    <label>New Password</label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="form-control"
                      placeholder="New Password"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      value={rePassword}
                      onChange={(e) => setRePassword(e.target.value)}
                      className="form-control"
                      placeholder="Re-enter New Password"
                    />
                  </div>
                  <div className="form-group mt-4">
                    <button
                      onClick={handleReset}
                      className="btn btn-primary btn-lg btn-block"
                    >
                      Reset Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  );
};

export default ResetPassword;
